// import * as types from "../mutation-types";
import axios from "axios";
import { API } from "../../mixins/constants";
import { file } from "../../store/api/api";

const state = {};
const getters = {};
const actions = {
  /* eslint-disable */

  async uploadImageID({ commit }, fileData) {
    return new Promise((resolve, reject) => {
      const url = `${process.env.VUE_APP_ADMIN_API_URL}${API.supplier.file_upload}?file_id=${fileData.file_id}&api_key=${process.env.VUE_APP_API_KEY}&time=${Math.round(new Date().getTime() / 1000)}`;
      let formData = new FormData();
      formData.append("file", fileData);
      axios({
        method: "POST",
        url: url,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          // console.log("error", error);
          reject(error);
        });
    });
  },

  async uploadAvatar({ commit }, file) {
    return new Promise((resolve, reject) => {
      const url = `${process.env.VUE_APP_API_URL}${API.supplier.upload_file}`;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("token", file.supplier_token);
      formData.append("file_id", "avatar");

      axios({
        method: "POST",
        url: url,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async getAvatar({ commit }, data) {
    return new Promise((resolve, reject) => {
      file(data)
        .then(response => {
          if (response) {
            // commit(types.SET_DATA_PROFILE, response);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  }
};
const mutations = {};

export default {
  state,
  mutations,
  actions,
  getters
};
